<div id="linkOwnerDeviceCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@linkownerdevice_details">Collega dispositivo</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div class="control-card-content">

    <div id="messageDiv">
      <p class="linkownerdevice-msg">
        <ng-container i18n="@@linkownerdevice_msg">Seleziona il dispositivo che vuoi collegare a </ng-container>
        {{owner?.displayName}}<br />
      </p>
    </div>


    <div id="table-filter-container">
      <div class="table-filter">
        <input id="filter-input" (keyup)="onKey($event)" />
        <p i18n="@@linkownerdevice_filter">Filtra: </p>
      </div>
    </div>

    <br clear="all" />


    <!-- <table mat-table matSort #linkownerdevicetable class="simple-table" >

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_name">Nome</th>
                <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
            </ng-container>

            <ng-container matColumnDef="serial">
                <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_serial">Seriale</th>
                <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
            </ng-container>

            <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_type">Versione</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.systemInfo.version }}
                    <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
                [class.mat-cell-selected]="selectedRow == row.id" class="clickable" >
            </tr>

        </table> -->
    <div id="devicesList">
      <table mat-table matSort #linkownerdevicetable class="simple-table">

        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@linkownerdevice_name">Nome</th>
          <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>

        <ng-container matColumnDef="serial">
          <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@linkownerdevice_serial">Seriale</th>
          <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
        </ng-container>

        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_type">Versione</th>
          <td mat-cell *matCellDef="let element"> {{ element.systemInfo.version }} </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_city">Città</th>
          <td mat-cell *matCellDef="let element"> {{ element.systemInfo.city }} </td>
        </ng-container>


        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef i18n="@@linkownerdevice_address">Indirizzo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.systemInfo.address }}
            <fa-icon icon="chevron-right" class="float-right padding-5"></fa-icon>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"
          [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
        </tr>

      </table>

    </div>
    <app-loading-screen #linkownerdeviceloader></app-loading-screen>

  </div>

</div>
